"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/newArrowCheck"));

var _this = void 0;

var _default = function (v) {
  (0, _newArrowCheck2.default)(this, _this);
  return {}.toString.call(v) === '[object Object]';
}.bind(void 0);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud-fe/react-components/lib/utils/isObject.js
// module id = 1426
// module chunks = 4 6 7 8 10 17 18